module.exports = __webpack_public_path__ + "static/Residential_bg-f6268d02db6c49f2fe9d78db7075cc33.jpg";